<div class="text-right">
  <button class="alert alert-{{alertType}}" mat-button (click)="dismiss($event)">OK</button>
</div>
<div class="conteudo">
  <p *ngFor="let mensagem of dados">{{mensagem}}</p>
</div>
